import React from "react";
import styles from "./styles.scss";
import { Status } from "./status";

function Loader() {
  return (
    <div className={styles.statuses}>
      <Status />
      <Status />
      <Status />
      <Status />
      <Status />
      <Status />
      <Status />
      <Status />
      <Status />
    </div>
  );
}

export { Loader };
